import { faPuzzlePiece } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { DefaultForm } from "../../components";
import { EntityReplaceModel } from "../../entities/common";
import { useGetProductsSelectFilterQuery } from "../../features/api/productApi";

interface ProductReplacerProps {
  replaceCallback: (data: EntityReplaceModel) => Promise<boolean>;
}

export const ProductReplacer = ({
  replaceCallback,
}: ProductReplacerProps) => {
  const [isReplacing, setIsReplacing] = useState(false);

  let model: EntityReplaceModel = {
    id: undefined,
    replaceId: undefined
  };

  const onFinish = async (values: any) => {
    let replaceModel: EntityReplaceModel = {
      ...values,
    };

    setIsReplacing(true);

    const isSuccess=await replaceCallback(replaceModel);

    setIsReplacing(false);

    if(isSuccess) {
         
    }
  };

  return (
    <DefaultForm onFinish={onFinish} layout="vertical" initialValues={model}>
      <DefaultForm.DataSelect
        name="id"
        label="محصول غلط"
        placeholder="انتخاب محصول"
        wrapperCol={{ xs: 24, md: 18, lg: 12, xl: 6 }}
        query={useGetProductsSelectFilterQuery}
        displayText={(x) => x.name}
      />

      <DefaultForm.DataSelect
        name="replaceId"
        label="محصول جایگزین"
        placeholder="انتخاب محصول"
        wrapperCol={{ xs: 24, md: 18, lg: 12, xl: 6 }}
        query={useGetProductsSelectFilterQuery}
        displayText={(x) => x.name}
      />

      <DefaultForm.SubmitButton
        loading={isReplacing}
        icon={<FontAwesomeIcon className="anticon" icon={faPuzzlePiece} />}
      >
        جایگزینی
      </DefaultForm.SubmitButton>
    </DefaultForm>
  );
};
